import { useEffect, useState } from 'react'
import useFirstRender from '../../hooks/FirstRender';
import LoadMore from '../../components/common/LoadMore';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useApiProgress } from '../../hooks/ApiProgress';
import { ENTITY_IS_IN_USE_MESSAGE, EXCEL_VALIDATION_MESSAGE } from '../../utils/constants';
import { toast } from 'react-toastify';
import Input from '../../components/Input';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import Button from '../../components/Button';
import { GoPlus } from 'react-icons/go';
import { onChange } from '../../utils/functions';
import DeleteModal from '../../components/DeleteModal';
import { WEIGHT_PATH, deleteWeight, downloadWeightExcelFile, getPageWeights, uploadWeightExcelFile } from '../../api/weightApi';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { pageModel } from '../../utils/model';
import readXlsxFile, { readSheetNames } from 'read-excel-file';

const WeightListPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [weightPage, setWeightPage] = useState(pageModel)
    const pendingApiCall = useApiProgress('get', `${WEIGHT_PATH}/page`, false)
    const pendingApiCallDelete = useApiProgress('delete', `${WEIGHT_PATH}`, false)
    const [searchParams, setSearchParams] = useState({
        id: "",
        code: "",
        name: "",
        description: ""
    })
    const [isOpen, setIsOpen] = useState(false)
    const [deleteId, setDeleteId] = useState(undefined)
    const [searchTimer, setSearchTimer] = useState();

    useEffect(() => {
        weightPage.content.length === 0 && loadWeights({ size: 20 })
    }, [])

    const onLoadMore = () => {
        if (!weightPage.last) {
            loadWeights({ ...searchParams, lastId: weightPage.content[weightPage.content.length - 1]?.id })
        }
    }

    useEffect(() => {
        !isFirstRender && searching(searchParams)
    }, [searchParams])

    const loadWeights = (params) => {
        !pendingApiCall &&
            getPageWeights(params)
                .then(res => {
                    setWeightPage(prevState => ({ ...res.data, content: [...prevState.content, ...res.data.content] }))

                })
    }

    const searching = async (params) => {
        if (searchTimer) clearTimeout(searchTimer);
        let timer = setTimeout(() => {
            getPageWeights(params)
                .then(res => {
                    setWeightPage(res.data)
                })
        }, 500);
        setSearchTimer(timer);
    }

    const onClickDelete = () => {
        deleteWeight(deleteId)
            .then(res => {
                setIsOpen(false)
                setWeightPage(prevState => ({ ...prevState, content: prevState.content.filter(p => p.id !== deleteId) }))
                toast.success('Silindi')
            }).catch(err => {
                toast.error(ENTITY_IS_IN_USE_MESSAGE)
            })
    }

    const uploadExcelFile = async (event) => {
        const file = event.target.files[0];
        if (!Boolean(file)) return;
        const sheets = await readSheetNames(file);
        let rows;
        for (const sheet of sheets) {
            rows = await readXlsxFile(file, { sheet });
            rows.shift();
        }
        const items = []
        for (const row of rows) {
            items.push({
                code: row[0],
                name: row[1],
                description: row[2]
            })
        }
        uploadWeightExcelFile(items)
            .then(res => {
                setWeightPage({ ...pageModel, content: res.data })
                toast.success("Kayıtlar yüklendi")
            }).catch(err => {
                toast.error(EXCEL_VALIDATION_MESSAGE)
            })
    }

    const downloadExcelFile = () => {
        downloadWeightExcelFile().then(res => {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'gramaj.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);
        }).catch(err => {
            toast.error('Dosya indirilirken hata oluştu!')
        })
    }

    return (
        <div>
            <div className='mb-1 border-b border-zinc-300'>
                <label className='text-2xl'>
                    GRAMAJ
                </label>
            </div>
            <div className='flex gap-x-2 py-2 sticky top-0 bg-zinc-50'>
                <Button
                    text={<label className='flex items-center gap-x-1'><GoPlus />Yeni Gramaj</label>}
                    variant='green'
                    onClick={() => nav('/weight/add')}
                />
                {/* <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-upload'
                >
                    <RiFileExcel2Fill />
                    <span> Excel Yükle</span>
                </label> */}
                <label
                    className='bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-500 flex items-center gap-x-1 px-2 py-1 text-white text-md rounded-sm'
                    htmlFor='excel-download'
                    onClick={downloadExcelFile}
                >
                    <FaCloudDownloadAlt />
                    <span> Excel İndir</span>
                </label>
                {/* <input className='hidden' id='excel-upload' type='file' accept='.xls, .xlsx' onChange={e => uploadExcelFile(e)} /> */}
            </div>
            <table className='w-full text-left text-zinc-900 mb-10 text-sm'>
                <thead className='text-xs uppercase tracking-wide sticky top-12 bg-zinc-50'>
                    <tr>
                        <th className='p-2 w-1/12'>Id</th>
                        <th className='p-2 w-3/12'>Gramaj Kodu</th>
                        <th className='p-2 w-3/12'>Gramaj Adı</th>
                        <th className='p-2 w-4/12'>Açıklama</th>
                        <th className='p-2 w-1/12'>Aksiyon</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className='border-b items-center sticky top-20 bg-zinc-50'>
                        <td className='px-2'>
                            <Input
                                name="id"
                                placeholder='Id...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="code"
                                placeholder='Gramaj kodu...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td className='px-2'>
                            <Input
                                name="name"
                                placeholder='Gramaj adı...'
                                onChange={e => onChange(e, setSearchParams)}
                            />
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                    </tr>
                    {
                        weightPage.content.map((weight, index) => (
                            <tr key={index} className='border-b items-center hover:bg-violet-100 duration-150'>
                                <td className='p-2'># {weight.id} </td>
                                <td className='p-2'>{weight.code} </td>
                                <td className='p-2'>{weight.name}</td>
                                <td className='p-2 '>{weight.description}</td>
                                <td className='p-2 items-center'>
                                    <div className='flex gap-x-3'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => nav(`/weight/edit/${weight.id}`)}>
                                            <AiFillEdit />
                                        </span>
                                        <span
                                            className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                            onClick={() => {
                                                setIsOpen(true)
                                                setDeleteId(weight.id)
                                            }}
                                        >
                                            <AiFillDelete />
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            <LoadMore page={weightPage} pending={pendingApiCall} onLoadMore={onLoadMore} />
            <DeleteModal
                isOpen={isOpen}
                closeModal={() => setIsOpen(false)}
                onClick={onClickDelete}
                pendingApiCall={pendingApiCallDelete}
            />
        </div >
    )
}

export default WeightListPage